import type {clientContactsRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const clientContactsSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type ClientContactsSearch = z.output<typeof clientContactsSearchSchema>;
export type ClientContactsNavigateFn = ReturnType<typeof clientContactsRouteApi.useNavigate>;
